import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { fixBody, resetBody } from "@utils";

export default function useFixBody(
	useFixedPosition: boolean,
	isOpened?: boolean,
	elementId?: string
) {
	const { pathname } = useLocation();

	useEffect(() => {
		if (pathname.includes("live")) {
			return;
		}

		if (isOpened) {
			fixBody(useFixedPosition, elementId);
		} else {
			resetBody(useFixedPosition, false, elementId);
		}

		return () => resetBody(useFixedPosition, false, elementId);
	}, [isOpened]);
}
